export enum DataTypesEnum {
    Messages = 1,
    Contacts,
    Lists,
    SmsReports,
    EmailReports
  }